import React from 'react';
import { Download } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '../ui/dropdown-menu';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const FORMATS = [
  ['png', 'PNG', 'original'],
  ['transparent', 'Transparent PNG', 'background removed'],
  ['jpg', 'JPEG', 'white background'],
  ['svg', 'SVG vector', 'scalable, for print & signs'],
];

export default function ImageDownloadMenu({ visionId, srcId, compact = false, testid }) {
  const tid = testid || `download-${srcId}`;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" onClick={(e) => e.stopPropagation()} data-testid={tid} title="Download"
          className={compact ? 'p-1 rounded-md bg-white/90 border border-[#E2E8F0] text-[#475569] hover:text-[#1D4ED8]'
            : 'flex-1 inline-flex items-center justify-center gap-1 py-1.5 rounded-lg text-xs font-bold border border-[#E2E8F0] text-[#475569] hover:border-[#1D4ED8] hover:text-[#1D4ED8]'}>
          <Download size={compact ? 12 : 12} />{!compact && ' Download'}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()}>
        <DropdownMenuLabel>Download as</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {FORMATS.map(([f, label, hint]) => (
          <DropdownMenuItem key={f} asChild>
            <a href={`${BACKEND}/api/website-vision/${visionId}/download/${srcId}?fmt=${f}`} download data-testid={`${tid}-${f}`} className="cursor-pointer flex flex-col items-start">
              <span className="font-semibold text-sm">{label}</span><span className="text-[11px] text-[#94A3B8]">{hint}</span>
            </a>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
